module.exports = __webpack_public_path__ + "static/media/planNavLogoNew.d1e6b813.svg";